import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatComponent } from './chat.component';
import { chatRoutingModule } from './chat-routing.module';
import { ChatUsersComponent } from './chat-users/chat-users.component';
import { ChatFilesComponent } from './chat-files/chat-files.component';
import { ChatHolderComponent } from './chat-holder/chat-holder.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { DocumentViewerComponent } from './document-viewer/document-viewer.component';
//import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatTabsModule} from '@angular/material/tabs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [ChatComponent, ChatUsersComponent, ChatFilesComponent, ChatHolderComponent,
    DocumentViewerComponent],
  imports: [
    CommonModule,
    chatRoutingModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    FormsModule,
    MatMenuModule,
    MatDialogModule,
    MatCardModule,
    MatCheckboxModule,
    NgxDocViewerModule,
    ReactiveFormsModule,
    MatTabsModule,
    MatProgressSpinnerModule,

    //InfiniteScrollModule
  ],
  providers: [LoaderService],

})
export class ChatModule { }
